interface IProps {
    color?: string;
    size?: number;
    onClick?: () => void;
    stoke?: string;
}
export const IconPdpa = (props: IProps) => {
    const { size, color } = props;
    return (
        <svg width={size || "20"} height={size || "22"} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="9.889" cy="20.0761" rx="5.33333" ry="1.55556" fill="#D8E8E2" />
            <path d="M7.66667 4.2985H3.66667V7.93877L1 10.3285L3.66667 12.7183V16.2985H7.66667L9.88889 19.4096L12.1111 16.2985H16.1111V12.7183L18.7778 10.3285L16.1111 7.93877V4.2985H12.1111L9.88889 1.63184L7.66667 4.2985Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
            <path d="M7.22217 10.0765L8.99995 11.8543L12.1111 8.74316" stroke={color || "#336C51"} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

};
